<template>
    <div>
        <div class="alert alert-success" role="alert" v-if="success">
            {{this.title}} successfully created!
        </div>
        <label class="col-12 control-label">{{this.title}}</label>
        <div class="col-12">
            <color-picker
                    theme="light"
                    :color="color"
                    :sucker-hide="true"
                    :colors-default="[]"
                    @changeColor="changeColor"
            />
        </div>
        <div class="col-12 mt-3">
            <button type="button" class="btn btn-primary btn-sm" @click="submit">Opslaan</button>
        </div>
    </div>
</template>
<script>
    import colorPicker from '@caohenghu/vue-colorpicker';

    export default {
        name: 'customColorPicker',
        props: ['title', 'attribute', 'color'],
        data() {
            return {
                // color: '#59c7f9',
                colorHex: null,
                // customColor: null,
                isLoading: false,
                success: false,

            };
        },
        components: {
            colorPicker
        },
        mounted(){
            this.colorHex = this.color
        },
        watch:{
          success(){
              setTimeout(() => {
                  this.success = false
              }, 3000);
          }
        },
        methods: {
            changeColor(color) {
                const {r, g, b, a} = color.rgba
                // this.colorHex = color.hex
                this.colorHex = `rgba(${r}, ${g}, ${b}, ${a})`
                this.$emit('changeValue',{color:this.colorHex, attribute:this.attribute})
            },
            submit() {
                        //Moet in array voor backend
                        this.$store.dispatch('UPDATE_SETTING_OPTION', {option: this.attribute, value: this.colorHex})
                            .then(() => {
                                this.success = true
                            })
                            .catch((error) => {
                            })
            },
        },
    }
</script>
<style scoped>
    .hu-color-picker {
        width: 225px !important;
    }
</style>
